import { styled, Button } from "@mui/material";
import React from "react";

export const StyledSquareMenuButton = styled(Button)(({ theme }) => ({
  padding: 0,
  borderRadius: 1,
}));
